/** Dependency-free so workspaceArtifacts can import it without pulling the thread UI into the shared chunk. */
export function reviewReportArtifactId(childSessionId: string): string {
  return `review-report:${childSessionId}`;
}
